import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faCopy, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        Permisos:[],
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Producto?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("productos/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarArrayResultado(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    copiar = (id) => {
        Swal.fire({
            title: 'Está seguro de Copiar el Producto?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Copiar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("productos/copiar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('UCAP!', datosRespuesta.data.msj, 'success')
                        //this.ListarArrayResultado(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };
    ConsultarPermiso() {

        let user = localStorage.getItem('idusuario');
        let url = 'MasterProductos';

        authAxios.get("roles/PermisoModulo/" + user + "/" + url + "")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Permisos: datosRespuesta.data.data });
             
            })
            .catch(console.log);
    }
    ListarArrayResultado(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        let cat = document.getElementById('bcategoria').value;
        let cod = document.getElementById('bcodigo').value;
        let bmun = document.getElementById('bmunicipio').value;
        let global = document.getElementById('global').value;
     
        var datos = {nombre:bname, municipio:bmun, codigo:cod, categoria:cat,global:global}
        authAxios.post("productos/index_new?page="+page, datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', arrayResultado: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
                Swal.close();
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    componentDidMount() {
        this.ConsultarPermiso();
        this.ListarArrayResultado(1);
    }
    render() {
        const { load, arrayResultado, pagina, ultimo, actual,Permisos } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            {Permisos.registrar==1?
                            <Link className="btn btn-success btn-sm" to={"/AddProductos"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Producto</Link>
                            :''}
                        </div>
                        <div className="card-body">
                            <h4>Lista de Productos A.P.U</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <input  type="text" id="bcodigo" name="bcodigo" placeholder="Codigo" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <input  type="text" id="bnombre" name="bnombre" placeholder="Producto" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-2">
                                    <input  type="text" id="bcategoria" name="bcategoria" placeholder="Buscar x categoria" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-2">
                                    <input  type="text" id="bmunicipio" name="bmunicipio" placeholder="Buscar x municipio" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-2">
                                <select  className="form-select form-select-sm" name="global" id="global">
                                    <option value="0">Material Global</option>
                                    <option value="1">Material Historico</option>
                                </select>
                                </div>
                                <div className="col-xl-2">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">CÓDIGO</th>
                                            <th className="align-middle">DESCRIPCIÓN DEL PRODUCTO</th>
                                            <th className="align-middle">UNIDAD</th>
                                            <th className="align-middle">CATEGORÍA</th>
                                            <th className="align-middle">ESTADO</th>
                                            <th className="align-middle">FEC. ACTUALIZACIÓN</th>
                                            <th className="align-middle">MUNICIPIO</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            arrayResultado.map((itemArrayResultado) => (
                                                <tr key={itemArrayResultado.ID_PRODUCTO}>
                                                    <td>{itemArrayResultado.CODIGO}</td>
                                                    <td>{itemArrayResultado.PRODUCTO}</td>
                                                    {
                                                        (() => {
                                                            switch (itemArrayResultado.ID_TIPO_UNIDAD) {
                                                                case 1:
                                                                    return (<td>GLB</td>)
                                                                case 2:
                                                                    return (<td>M</td>)
                                                                case 3:
                                                                    return (<td>ROLLO</td>)
                                                                case 4:
                                                                    return (<td>UND</td>)
                                                            }
                                                        })()
                                                    }
                                                    <td>{itemArrayResultado.NOMBRE}</td>
                                                    {
                                                        (() => {
                                                            switch (itemArrayResultado.ESTADO) {
                                                                case 0:
                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-danger">INACTIVO</span></td>)
                                                                case 1:
                                                                    return (<td><span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">ACTIVO</span></td>)

                                                            }
                                                        })()
                                                    }
                                                    <td>{itemArrayResultado.FECHA_ACTUALIZACION}</td>
                                                    <td>{itemArrayResultado.MUNICIPIO_RELACIONADO}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                        {Permisos.editar==1?
                                                            <Link
                                                                className="btn btn-primary btn-sm"
                                                                to={"/UpProductos/" + itemArrayResultado.ID_PRODUCTO}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>:''} &nbsp;&nbsp;
                                                            {Permisos.eliminar==1?
                                                            <><button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemArrayResultado.ID_PRODUCTO)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>
                                                            <button
                                                            type="button"
                                                            className="btn btn-info btn-sm"
                                                            onClick={() =>
                                                                this.copiar(itemArrayResultado.ID_PRODUCTO)
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon={faCopy} />
                                                        </button></>:''}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResultado(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;